import { gql } from '@apollo/client'

export const Query = gql`
  query EditDocumentType($companyId: ID!, $filters: DocumentTypeFilters) {
    documentTypes(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        subject
        dateDue
        dateIssued
        freeagentResource
        xeroResource
        incrementStart
        incremental
        crewVisible
        size
        orientation
        documentTypeBlocks { id blockType margins { top bottom left right } options { color } template }
        previewUrl
      }
    }
  }
`
